export default {
    profile: (state) => state.profile,
}
